



































import { Upload } from 'element-ui'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

interface ListItem {
  type?: 'component' | 'text'
  component?: any
  props?: Record<string, any>
  iconClass?: string
  item?: string | any
  click?: () => void
}

@Component({
  components: {
    [Upload.name]: Upload,
  },
})
export default class ListWithIcons extends Vue {
  @Prop() items!: ListItem[]

  handleItemClick(item: ListItem) {
    if (item.click && typeof item.click === 'function') {
      item.click()
    }
  }
}
